import React from "react";
import { Table } from "antd";
import styled from "styled-components";
import { transformICFProtocolToSessions } from "../../../services/functions";

export const TransparentTable = styled(Table)`
  background: transparent !important;
  color: #426bba;
  margin-top: 1rem;

  .ant-table,
  .ant-table-container,
  .ant-table-content,
  .ant-table-body {
    background: transparent !important;
    color: #426bba;
  }

  /* Header cells */
  .ant-table-thead > tr > th {
    background: #426bba !important;
    color: #FFF !important;
    border-bottom: 1px solid #bfd3f2 !important;
    border-right: 1px solid #bfd3f2 !important;
    font-weight: 600;
  }

  /* Body cells */
  .ant-table-tbody > tr > td {
    background: transparent !important;
    color: #426bba !important;
    border-bottom: 1px solid #bfd3f2 !important;
    border-right: 1px solid #bfd3f2 !important;
  }

  /* Remove extra border on last column */
  .ant-table-thead > tr > th:last-child,
  .ant-table-tbody > tr > td:last-child {
    border-right: none !important;
  }

  /* ===== CLICKABLE CURSOR ===== */
  .ant-table-tbody > tr {
    cursor: pointer;
  }

  /* Hover effect */
  .ant-table-tbody > tr:hover > td {
    background: rgba(66, 107, 186, 0.08) !important;
  }

  /* Active row highlight */
  .active-session-row td {
    background: rgba(66, 107, 186, 0.15) !important;
  }

  /* Outer border */
  &.ant-table-bordered {
    border: 1px solid #bfd3f2 !important;
  }

  /* OUTER BORDER FIX */
  .ant-table-container {
    border: 1px solid #bfd3f2 !important;
    border-radius: 8px;
    overflow: hidden;
  }

  /* Pagination text */
  .ant-pagination-item,
  .ant-pagination-prev,
  .ant-pagination-next,
  .ant-pagination-item-link {
    color: #426bba !important;
    border-color: #bfd3f2 !important;
  }

  /* Active page */
  .ant-pagination-item-active {
    border-color: #bfd3f2 !important;
  }

  .ant-pagination-item-active a {
    color: #426bba !important;
  }
`;

export default function SessionHistoryTable({ protocols, loading, onSelectSession }) {
    const sessionRows = transformICFProtocolToSessions(protocols);

    const columns = [
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            width: 90,
        },
        {
            title: "Protocol",
            dataIndex: "protocol",
            key: "protocol",
            ellipsis: true,
        },
    ];

    return (
        <TransparentTable
            rowKey="key"
            columns={columns}
            dataSource={sessionRows}
            loading={loading}
            size="small"
            pagination={{
                pageSize: 5,
                size: "small",
            }}
            bordered
            rowClassName={(record) =>
                record.isActive ? "active-session-row" : ""
            }
            onRow={(record) => ({
                onClick: () => {
                    onSelectSession?.(record);
                },
            })}
            style={{ background: "transparent" }}
        />
    );
}
